import { render, staticRenderFns } from "./requester-type.vue?vue&type=template&id=b176a5f6&"
import script from "./requester-type.vue?vue&type=script&lang=js&"
export * from "./requester-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports